module.exports = __webpack_public_path__ + "img/pin.7ca307b1.svg";